<div class="dialog-heading">
  <h5>{{ data.title }}</h5>
  <span class="flex-fill"></span>
  <mat-icon class="close-dialog" aria-hidden="false" [mat-dialog-close]="{ confirmed: false }" aria-label="Close icon"> close</mat-icon>
</div>

<mat-dialog-content [formGroup]="sendOfferForm">
  <div class="padTop">
    <label class="feedback-label">Notes</label>
    <mat-form-field class="full-width" appearance="outline">
      <textarea rows="6" class="quoteFeedback full-width" matInput formControlName="notes"></textarea>
      <mat-error> Cannot be more than 255 characters. </mat-error>
    </mat-form-field>
  </div>
</mat-dialog-content>

<!-- This are the actions of the dialog, containing the primary and the cancel button-->
<mat-dialog-actions class="actions">
  <button mat-flat-button color="accent" (click)="send()">Send</button>
  <button mat-stroked-button color="accent" [mat-dialog-close]="{ confirmed: false }">Cancel</button>
</mat-dialog-actions>
